import { track, trackEvent, trackPage } from '@a0/docs-components/metrics';
export default function createMetricsPlugin() {
    return {
        name: 'MetricsPlugin',
        plugContext: function () { return ({
            plugComponentContext: function (componentContext) {
                componentContext.trackEvent = track;
                componentContext.trackPage = trackPage;
            },
            plugActionContext: function (actionContext) {
                actionContext.trackEvent = trackEvent;
                actionContext.trackPage = trackPage;
            },
            dehydrate: function () {
                //
            },
            rehydrate: function () { return null; },
        }); },
    };
}
